import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { roleid, token } from "../Actions/AuthAction";
import { CandidateAppliedDriveList } from "../Actions/DriveAction";
import Shimmer from "../Common/Shimmer";

export const SelectedDriveList = () => {
  const [page, setpage] = useState(1);
  const [totaldrive, settotaldrive] = useState(0);
  const [driveList, setdriveList] = useState(null);
  const [userrole, setuserrole] = useState(null);

  useEffect(() => {
    getData();
    setuserrole(roleid());
  }, []);

  const renderDrive = () => {
    return (
      <>
        {driveList.map((item, index) => (
          <div className="col-md-12" key={index}>
            <div className="card formcard mb-3">
              <div className="card-body">
                <div className="d-flex justify-content-between pb-2 border-bottom">
                  <div className="d-flex justify-content-start">
                    <div className="ml-3">
                      <h4 className="mb-0">
                        <Link to={`/drivedetail/${item.drive.driveid}`}>
                          {item.drive.drivename}
                        </Link>
                      </h4>
                    </div>
                    <div></div>
                  </div>
                  <div className="header-btn">
                    {userrole == 5 ? (
                      <Link
                        to={`/candidatedetail/${item.drive.driveid}/${item.candidate.id}`}
                        className="btn btn-primary-custom mx-2 d-block mb-2"
                      >
                        <i class="fas fa-list"></i> View Details
                      </Link>
                    ) : null}
                    {/* {item.institutestatus == 1 ? <a className="btn btn-secondary-custom mx-2 d-block mb-2" href="#">Not Verified</a> :
                item.institutestatus == 2 ? <a className="btn btn-secondary-custom mx-2 d-block mb-2" href="#">Verified</a> :
                  <a className="btn btn-secondary-custom mx-2 d-block mb-2" href="#">Rejected</a>} */}
                  </div>
                </div>
                <div className="d-flex justify-content-between pt-3 joblisting">
                  <div className="col-md-2">
                    <ul className="font-weight-bold">
                      <li>Drive id:</li>
                      <li>Drive Start Date:</li>
                      <li>Drive End Date:</li>
                      <li>Institute:</li>
                    </ul>
                  </div>
                  <div className="col-md-10">
                    <ul>
                      <li>#{item.drive.driveid}
                        {item.drive.drivestatus == 2 ? (
                          <span className="badge badge-pill badge-success mx-1 p-1 my-1">
                            Open
                          </span>
                        ) : (
                          <span className="badge badge-pill badge-danger mx-1 p-1 my-1">
                            Closed
                          </span>
                        )}
                        {item.drive.drivetype == 1 ? (
                          <span className="badge badge-pill badge-warning mx-1 p-1 my-1">
                            Single
                          </span>
                        ) : (
                          <span className="badge badge-pill badge-dark mx-1 p-1 my-1">
                            Pool
                          </span>
                        )}
                      </li>
                      <li>{item.drive.drivestartdate}</li>
                      <li>{item.drive.driveenddate}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </>
    );
  };

  const getData = () => {
    getDrive();
  };
  const getDrive = (truePage = page) => {
    CandidateAppliedDriveList({
      loginusertoken: token(),
      page: truePage,
      applystatus: 2,
    }).then((res) => {
      settotaldrive(res.totaldata);
      setdriveList(res.data);
    });
  };
  const changePage = (value) => {
    const truePage = page + value;
    setpage(page + value);
    window.scroll(0, 0);
    getDrive(truePage);
  };
  const to = (page - 1) * 5 + 1;
  const from = page * 5 > totaldrive ? totaldrive : page * 5;
  return (
    <React.Fragment>
      <div className="row mb-4">
        <div className="col-md-12">
          <h4 className="table_heading position-relative">
            SELECTED DRIVE LIST
          </h4>
        </div>
      </div>
      <div className="d-flex justify-content-between">
        <p className="text-black font-weight-bold">{totaldrive} Drive</p>
        <p className="text-secondary">
          Jobs {to} to {from} of {totaldrive}
        </p>
      </div>
      <div className="row">
        <div class="col-md-3 order-sm-12">
          <div class="card formcard p-2">
            <p class="text-black font-weight-bold table_heading position-relative">Filter</p>
            <form class="form-group"><div class="form-group col-md-12"><label class="mb-1" for="inputEmailAddress">Start Date</label>
              <div><input type="datetime-local" class="form-control rounded-pill" value="" /></div>
            </div>
              <div class="form-group col-md-12"><label class="mb-1" for="inputEmailAddress">End Date</label>
                <div><input type="datetime-local" min="" class="form-control rounded-pill" value="" /></div>
              </div>
            </form>
          </div>
        </div>
        <div class="col-md-9 order-sm-1">
          {/* {jobList?renderJob():<Shimmer/>} */}
          {driveList ? renderDrive() : <Shimmer />}
          <ul className="d-flex justify-content-between list-unstyled pagination">
            <li className="px-3">
              {page == 1 ? (
                <a className="d-none">
                  <i className="fa fa-arrow-left" aria-hidden="true"></i> PREV
                </a>
              ) : (
                <a onClick={(e) => changePage(-1)}>
                  <i className="fa fa-arrow-left" aria-hidden="true"></i> PREV
                </a>
              )}
            </li>

            <li className="px-3">
              {driveList && driveList.length < 5 ? (
                <a className="d-none">
                  {" "}
                  <i className="fa fa-arrow-right" aria-hidden="true"></i>
                  NEXT
                </a>
              ) : (
                <a onClick={(e) => changePage(1)}>
                  {" "}
                  <i className="fa fa-arrow-right" aria-hidden="true"></i>
                  NEXT
                </a>
              )}
            </li>
          </ul>
        </div>
      </div>


    </React.Fragment>
  );
};
